// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WebOperationModel from '../../model/web-operation-model';
import WebOperationDTO from '../dto/web-operation-dto';
import dtoSchema from '../schemas/web-operation-schema';
import WebOperationEquipmentModel from '../../model/web-operation-equipment-model';

export default abstract class WebOperationModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WebOperationDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.alertedOn = data.alertedOn;
      this.description = data.description ?? undefined;
      this.link = data.link ?? undefined;
      this.operationNumber = data.operationNumber;
      this.organisationId = data.organisationId;
      this.organisationName = data.organisationName ?? undefined;
      this.location = data.location ?? undefined;
      this.damageType = data.damageType ?? undefined;
      this.numberAdfOnDuty = data.numberAdfOnDuty;
      this.totalStaffHours = data.totalStaffHours;
      this.operationEquipment = data.operationEquipment?.map((i) => WebOperationEquipmentModel.toModel(i)) ?? [];
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;
  /**
  * @type {date-time}
  */
  alertedOn?: string;
  /**
  */
  description?: string;
  /**
  */
  link?: string;
  /**
  * @type {int64}
  */
  operationNumber?: number;
  /**
  * @type {uuid}
  */
  organisationId?: string;
  /**
  */
  organisationName?: string;
  /**
  */
  location?: string;
  /**
  */
  damageType?: string;
  /**
  * @type {int32}
  */
  numberAdfOnDuty?: number;
  /**
  * @type {double}
  */
  totalStaffHours?: number;
  /**
  */
  operationEquipment?: WebOperationEquipmentModel[];

  static toModel(dto: DeepPartial<WebOperationDTO>): WebOperationModel;
  static toModel(dto: DeepPartial<WebOperationDTO> | undefined | null): WebOperationModel | undefined;
  static toModel(dto: DeepPartial<WebOperationDTO> | undefined | null): WebOperationModel | undefined {
    return dto ? new WebOperationModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WebOperationModel> | WebOperationModel): WebOperationDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      alertedOn: unwrapped.alertedOn,
      description: unwrapped.description,
      link: unwrapped.link,
      operationNumber: unwrapped.operationNumber,
      organisationId: unwrapped.organisationId,
      organisationName: unwrapped.organisationName,
      location: unwrapped.location,
      damageType: unwrapped.damageType,
      numberAdfOnDuty: unwrapped.numberAdfOnDuty,
      totalStaffHours: unwrapped.totalStaffHours,
      operationEquipment: unwrapped.operationEquipment,
    } as WebOperationDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WebOperationModel, can not map to WebOperationDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
